import Head from "expo-router/head";

export function PageMeta(props: { title?: string; description?: string }) {
  const {
    title,
    description = "Collaborative swipe file, knowledge base, and bookmark manager",
  } = props;
  return (
    <Head>
      <title>{title ? `${title} | Savepad` : "Savepad"}</title>
      <meta name="description" content={description} />
      <meta property="og:site_name" content="Savepad" />
      <meta
        property="og:title"
        content={title ? `${title} | Savepad` : "Savepad"}
      />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://savepad.app/images/savepad-og.png"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="720" />
      <meta property="og:url" content="https://my.savepad.app" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@savepadapp" />
      <meta name="twitter:creator" content="@savepadapp" />
      <meta
        name="twitter:title"
        content={title ? `${title} | Savepad` : "Savepad"}
      />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content="https://savepad.app/images/savepad-og.png"
      />
    </Head>
  );
}
